/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForPeriodicCloudUsageBilling extends models.PeriodicBackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForPeriodicCloudUsageBilling");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForPeriodicCloudUsageBilling.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForPeriodicCloudUsageBilling>): BackgroundJobPayloadForPeriodicCloudUsageBilling {
        let obj = Object.assign(new BackgroundJobPayloadForPeriodicCloudUsageBilling(), model);
        BackgroundJobPayloadForPeriodicCloudUsageBilling.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForPeriodicCloudUsageBilling>): BackgroundJobPayloadForPeriodicCloudUsageBilling {
        if (!model) return null;
        return BackgroundJobPayloadForPeriodicCloudUsageBilling.newInstance(<BackgroundJobPayloadForPeriodicCloudUsageBilling> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForPeriodicCloudUsageBilling) {
        if (!obj) return;

        models.BackgroundJobPayloadForPeriodicCloudUsageBilling.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForPeriodicCloudUsageBilling): boolean {
        if (models.PeriodicBackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForPeriodicCloudUsageBilling.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
